import PropTypes from 'prop-types';
import always from "ramda/es/always";
import equals from "ramda/es/equals";
import ifElse from "ramda/es/ifElse";
import cx from "ramda-extension/es/cx";
import React from 'react';
import ArrowDown from '../../../../atoms/SvgIcon/Icons/ArrowDown';
import ArrowUp from '../../../../atoms/SvgIcon/Icons/ArrowUp';
import { useDefaultComponentValue } from '../../../../utils/useDefaultComponentValue';
import { labelPosition, sortDirection as sortDirectionConstant } from '../constants';
const COMPONENT_NAME = 'TableSortLabel';
const equalsSortAsc = equals(sortDirectionConstant.ASC);
const equalsPositionEnd = equals(labelPosition.END);
const getNewSortDirection = ifElse(equalsSortAsc, always(sortDirectionConstant.DESC), always(sortDirectionConstant.ASC));
const TableSortLabel = (inProps)=>{
    const props = useDefaultComponentValue({
        inProps,
        name: COMPONENT_NAME
    });
    const { descIcon = /*#__PURE__*/ React.createElement(ArrowDown, null), ascIcon = /*#__PURE__*/ React.createElement(ArrowUp, null), children, active, sortDirection = sortDirectionConstant.ASC, sortLabelPosition = labelPosition.START, onClick, name, iconClassName, className } = props;
    const handleSort = (event)=>{
        onClick?.(event, active ? getNewSortDirection(sortDirection) : sortDirection, name);
    };
    return /*#__PURE__*/ React.createElement("div", {
        onClick: handleSort,
        className: cx('Table-sortLabel', className)
    }, !equalsPositionEnd(sortLabelPosition) && children, /*#__PURE__*/ React.createElement("span", {
        className: cx('Table-sortIcon', iconClassName, {
            'Table-sortIcon--visible': active,
            'Table-sortIcon--end': equalsPositionEnd(sortLabelPosition)
        })
    }, equalsSortAsc(sortDirection) ? ascIcon : descIcon), equalsPositionEnd(sortLabelPosition) && children);
};
TableSortLabel.propTypes = {
    /**
	 * Whether we are currently soring by this instance of TableSortLabel
	 */ active: PropTypes.bool,
    /**
	 * Asceding sort icon node
	 */ ascIcon: PropTypes.node,
    /**
	 * Label elements or string
	 */ children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.node,
        PropTypes.string
    ]),
    /**
	 * Custom className for wrapper element
	 */ className: PropTypes.string,
    /**
	 * Descending icon node
	 */ descIcon: PropTypes.node,
    /**
	 * Custom className for icon element
	 */ iconClassName: PropTypes.string,
    /**
	 * Unique name used to identification for which column we should sort
	 */ name: PropTypes.string.isRequired,
    /**
	 * Function handler fired when wrapper is clicked on.
	 *
	 * @param {object} event event targeting the element.
	 * @param {string} string representation of new sorting direction.
	 * @param {string} unique name identification of clicked label.
	 * @return {void} void
	 */ onClick: PropTypes.func,
    /**
	 * String representation of one of two possible sorting directions
	 */ sortDirection: PropTypes.oneOf([
        sortDirectionConstant.ASC,
        sortDirectionConstant.DESC
    ]),
    /**
	 * Position of label string or element
	 */ sortLabelPosition: PropTypes.oneOf([
        labelPosition.START,
        labelPosition.END
    ])
};
export default TableSortLabel;
